import { type HsvaColor, hexToHsva, validHex } from "@uiw/color-convert";
import { formatParameterLabel, isHexColor } from "./parameter-label";

export const DEFAULT_HSVA: HsvaColor = { h: 0, s: 0, v: 100, a: 1 };

export function seedHsva(initialHex: string): HsvaColor {
  if (isHexColor(initialHex)) {
    return { ...hexToHsva(initialHex.toLowerCase()), a: 1 };
  }
  return DEFAULT_HSVA;
}

export function clampByte(n: number): number {
  return Math.min(255, Math.max(0, Math.round(n)));
}

/** Parse user hex input; returns lowercase ``#rrggbb`` or null if invalid. */
export function parseHexInput(raw: string): string | null {
  const normalized = raw.trim().replace(/^#/, "");
  const withHash = `#${normalized}`;
  if (withHash.length === 7 && validHex(withHash)) {
    return withHash.toLowerCase();
  }
  return null;
}

export function formatColorPickerGroupName(groupName?: string): string | null {
  if (!groupName || groupName.trim() === "") {
    return null;
  }
  return formatParameterLabel(groupName);
}

export function buildAssetCreateBody(name: string, selectedHex: string) {
  return {
    name: name.trim(),
    value: selectedHex,
    type: "color" as const,
  };
}

export function isColorPickerOkDisabled(
  isPending: boolean,
  saveAsAsset: boolean,
  trimmedName: string,
): boolean {
  return isPending || (saveAsAsset && trimmedName === "");
}
